<template>
	<v-dialog
		v-model="isVisible"
		:width="$vuetify.display.mobile ? '95%' : 'var(--sgnl-container-480)'"
		persistent
	>
		<v-card>
			<div class="tour-modal-title sgnl-text-color-default">
				<span class="sgnl-h6-medium">{{ title }}</span>
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="$emit('skip')"
				>
					<Close16 />
				</v-btn>
			</div>
			<div class="tour-modal-text sgnl-text-color-secondary sgnl-paragraph-m-regular">
				<slot>
					<div v-html="text" />
				</slot>
			</div>
			<TourStepFooter
				:stepNumber="stepNumber"
				:totalSteps="totalSteps"
				horizontalPadding="var(--sgnl-space-24)"
			>
				<slot name="actions" />
			</TourStepFooter>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
import TourStepFooter from "@/components/GuidedTour/TourStepFooter.vue";

export default defineComponent({
	name: "TourModalStep",
	components: { Close16, TourStepFooter },
	props: {
		modelValue: { type: Boolean, default: false },
		title: { type: String, required: true },
		text: { type: String, default: "" },
		stepNumber: { type: Number, required: true },
		totalSteps: { type: Number, required: true },
	},
	emits: ["update:modelValue", "skip"],
	computed: {
		isVisible: {
			get(): boolean {
				return this.modelValue;
			},
			set(value: boolean) {
				this.$emit("update:modelValue", value);
			},
		},
	},
});
</script>

<style lang="scss" scoped>
.tour-modal-title {
	display: flex;
	align-items: center;
	padding: var(--sgnl-space-12) var(--sgnl-space-24);
}

.tour-modal-text {
	padding: var(--sgnl-space-12) var(--sgnl-space-24);

	:deep(ul) {
		padding-left: var(--sgnl-space-20);
	}

	:deep(a) {
		color: var(--sgnl-brand-text);
		text-decoration: underline;
	}

	:deep(code) {
		background: var(--sgnl-default-secondary-background);
		padding: var(--sgnl-space-2) var(--sgnl-space-4);
		border-radius: var(--sgnl-border-radius-4);
	}
}
</style>
